import { connect } from "react-redux"

import BulkActionsCancelButton from "app/static/frontend/search-new/components/BulkActions/buttons/BulkActionsCancelButton"

import { setActiveActionButton } from "shared/search/action-creators"

const mapDispatchToProps = {
    setActiveActionButton,
}

export default connect(null, mapDispatchToProps)(BulkActionsCancelButton)
